<!-- Error Message -->
<ng-container *ngIf="errorText && !textOnly">
	<div class="alert alert-danger">{{ errorText }}</div>
</ng-container>

<ng-container *ngIf="errorText && textOnly">
	<span class="text-danger">{{ errorText }}</span>
</ng-container>

